// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4410) return "static/css/4410.0109b7a53e366eced4d6.css";
	if (chunkId === 7564) return "static/css/sender.d2fa50e600c8902170ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1412":"4f767f2564a62b1968c8","2788":"5d7ed240134bc0d577f0","6877":"201f07b8e64160d7069f"}[chunkId] + ".chunk.css";
};